(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/utils/math.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/utils/math.js');
"use strict";


function factorial(n) {
  if (isNaN(n)) {
    throw new Error('n needs to be a number');
  }
  if (!Number.isInteger(n)) {
    throw new Error('n needs to be an integer');
  }

  let result = 1;
  for (let i = 2; i <= n; i++) {
    result *= i;
  }
  return result;
}

function combination(numSelections, numRequiredSelections) {
  if (isNaN(numSelections)) {
    throw new Error('numSelections needs to be a number');
  }
  if (isNaN(numRequiredSelections)) {
    throw new Error('numRequiredSelections needs to be a number');
  }
  if (numSelections < numRequiredSelections) {
    return 0;
  }
  return factorial(numSelections) / (factorial(numRequiredSelections) * factorial(numSelections - numRequiredSelections));
}

function partialPermutation(numSelections, numRequiredSelections) {
  if (isNaN(numSelections)) {
    throw new Error('numSelections needs to be a number');
  }
  if (isNaN(numRequiredSelections)) {
    throw new Error('numRequiredSelections needs to be a number');
  }
  if (numSelections < numRequiredSelections) {
    return 0;
  }
  return factorial(numSelections) / factorial(numSelections - numRequiredSelections);
}

function isPOT(n) {
  if (isNaN(n)) {
    throw new Error('n needs to be a number');
  }
  return n && !(n & n - 1);
}

function countSetBits(number) {
  if (isNaN(number)) {
    throw new Error('number needs to be a number');
  }
  if (!Number.isInteger(number)) {
    throw new Error('number needs to be an integer');
  }
  let count = 0;
  for (count = 0; number > 0; count++) {
    number &= number - 1;
  }
  return count;
}
svs.racing.gameEngine.utils.math = {
  countSetBits,
  factorial,
  partialPermutation,
  combination,
  isPOT
};

 })(window);